import { isDomElement } from '~/utils'

const focusableSelector = [
  '[contentEditable=true]',
  '[tabindex]',
  'a[href]',
  'area[href]',
  'button:not([disabled])',
  'iframe',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
]
  .map(
    process.env.NODE_ENV === 'test'
      ? // TODO: Remove this once JSDOM fixes the issue where an element that is
        // "hidden" can be the document.activeElement, because this is not possible
        // in real browsers.
        (selector) =>
          `${selector}:not([hidden]):not([tabindex="-1"]):not([style*='display: none'])`
      : (selector) => `${selector}:not([hidden]):not([tabindex="-1"])`
  )
  .join(',')

export const focusTrap = (container, event) => {
  if (!isDomElement(container) || !event) return
  const focusable = getFocusable(container)
  const firstFocusable = focusable[0]
  let last = focusable.length - 1
  let lastFocusable = focusable[last]
  // prevents focus on PerfectScrollbar thumbs if they are empty
  while (
    ((lastFocusable.classList.contains('ps__thumb-x') &&
      lastFocusable.offsetWidth === 0) ||
      (lastFocusable.classList.contains('ps__thumb-y') &&
        lastFocusable.offsetHeight === 0) ||
      lastFocusable.classList.contains('react-datepicker__tab-loop__end')) &&
    last >= 0
  ) {
    lastFocusable = focusable[--last]
  }
  if (!event.shiftKey && event.target === lastFocusable) {
    event.preventDefault()
    event.stopPropagation()
    if (typeof firstFocusable.select === 'function') {
      firstFocusable.select()
    } else {
      firstFocusable.focus()
    }
  } else if (event.shiftKey && event.target === firstFocusable) {
    event.preventDefault()
    event.stopPropagation()
    lastFocusable.focus()
  }
}

export const getFocusable = (container) => {
  if (!isDomElement(container)) return []
  return container.querySelectorAll(focusableSelector)
}

export const goToNextFocusable = (container) => {
  const focusable = getFocusable(container)
  for (let i = 0; i < focusable.length; i++) {
    if (focusable[i] === document.activeElement && i < focusable.length - 1) {
      focusable[i + 1].focus()
      break
    }
  }
}

export const goToPreviousFocusable = (container) => {
  const focusable = getFocusable(container)
  for (let i = 0; i < focusable.length; i++) {
    if (focusable[i] === document.activeElement && i > 0) {
      focusable[i - 1].focus()
      break
    }
  }
}

export function isFocusableElement(element, mode = 'strict') {
  if (element === document.body) return false

  if (mode === 'strict') return element.matches(focusableSelector)

  let next = element

  while (next !== null) {
    if (next.matches(focusableSelector)) return true
    next = next.parentElement
  }

  return false
}
